import React from 'react'
import { PersonalTrainerHead } from '../index/service-category/personal-trainer/PersonalTrainerHead'
import { s3Static } from '../../utils/constants'
import { formatMoney } from '../../utils/format-money'
import { hasFeature } from '../../utils/markets'
import { lowestSessionPrice } from './PtPanels'
import { useMarketBooking } from './MarketBooking'

// Shown where the Singapore hero has its trainer strip, while the country has
// no trainer roster to show (utils/markets.js features.trainerRoster).
const HowItWorks = () => {
    const steps = [
        { title: 'Tell us your goal', body: 'Two minutes: goal, place and preferred times.' },
        { title: 'We match you', body: 'A certified trainer who fits your goal, within 48 hours.' },
        { title: 'Free consultation', body: 'Assessment and a plan before you commit.' },
    ]
    return (
        <ol className="grid gap-3 sm:grid-cols-3 text-left">
            {steps.map((step, i) => (
                <li key={step.title} className="rounded-2xl border border-white/10 bg-white/5 px-4 py-2">
                    <span className="text-xs font-bold text-orange-300">Step {i + 1}</span>
                    <p className="mt-1 font-semibold text-white">{step.title}</p>
                    <p className="mt-1 text-xs text-white/70">{step.body}</p>
                </li>
            ))}
        </ol>
    )
}

/**
 * UAE / Malaysia personal trainer hero: the Singapore PersonalTrainerHead,
 * driven by the surrounding <MarketBooking>. The free consultation and the
 * package cards open the booking form inside the hero, as on the SG page.
 *
 * Differences from Singapore: market prices, the "how it works" row instead of
 * the trainer strip (until features.trainerRoster), and no Google rating pill
 * (until features.googleRating) - those describe the Singapore business.
 */
export const MarketPtHero = ({ market, city, title, intro, heroCopy, image, spList }) => {
    const booking = useMarketBooking()
    const cd = market.countryCd
    const showRoster = hasFeature(market, 'trainerRoster') && spList?.length > 0

    return (
        <PersonalTrainerHead
            heroImage={s3Static + image}
            title={title}
            heading={title}
            intro={intro}
            heroCopy={heroCopy}
            spList={spList}
            strip={showRoster ? undefined : <HowItWorks />}
            pills={['Since 2018', 'No gym membership', 'Female trainers on request']}
            showRating={hasFeature(market, 'googleRating')}
            priceLabel={formatMoney(lowestSessionPrice(cd), cd, 0)}
            whatsAppText={`Hi StringsSG, I would like a free personal training consultation in ${city.name}.`}
            requestType="Fitness Trainer"
            requestCategorySettings={booking.settings}
            requestForm={booking.requestForm}
            setRequestForm={booking.setRequestForm}
            isQuickBook={booking.isQuickBook}
            setIsQuickBook={booking.setIsQuickBook}
            isCustomBook={booking.isCustomBook}
            openRequestForm={booking.openRequestForm}
        />
    )
}
